import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {SwitchInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SwitchInput'
import {TicketTierVisibilityInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/TicketTierVisibilityInput'
import {VisibilityInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/VisibilityInput'
import {StyledTitle} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'

export function DefaultBlockTopConfig(props: {
  values: any
  setFieldValue: any
}) {
  const {t} = useI18n()
  const {values, setFieldValue} = props

  return (
    <>
      <SwitchInput
        value={values.visible ?? false}
        name={'visible'}
        label={t('templateEditor.visibleToUsers')}
        setFieldValue={setFieldValue}
      />

      {values.visible ? (
        <TicketTierVisibilityInput
          value={values.visible_ticket_ids ?? []}
          name={'visible_ticket_ids'}
          setFieldValue={setFieldValue}
        />
      ) : null}

      <VisibilityInput
        value={values.visibility}
        name={'visibility'}
        label={t('templateEditor.visibleOnDevices')}
        setFieldValue={setFieldValue}
      />
      <StyledTitle>{t('templateEditor.sectionBasics')}</StyledTitle>
    </>
  )
}
